import React, { Component } from 'react';
import { Modal, Button, FormControl, Alert, Grid, Col, Row } from 'react-bootstrap';
import DomainList from "./domain-list";
import { SSL_OP_NO_TLSv1_2 } from 'constants';

class SuggestedDomainModal extends Component {
  constructor(props) {
    super(props);
    this.selectedDomainsUpdated = this.selectedDomainsUpdated.bind(this);
    this.submitAddDomain = this.submitAddDomain.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);
    this.selectAllDisabled = this.selectAllDisabled.bind(this);
    this.state = {
      SelectedDomains: [],
      DomainListDisabled: false,
      ParentDomainsAddedLimit : this.props.domainsAddedLimit,
      DomainsAddedLimit : this.props.domainsAddedLimit,
    }
    this.baseState = this.state;
  }

  handleModalClose(){
    //clear the selected domains in state
    this.setState(this.baseState);
    //propogate close to parent
    this.props.handleCloseAddDomainModal();
  }
  clearSelectedDomains(){
    this.setState({
      SelectedDomains:[],
    })
  }
  submitAddDomain({ target }) {
    this.props.handleAddDomain(this.state.SelectedDomains);
  }

  selectedDomainsUpdated(domains: Array) {
    this.setState({ 
      SelectedDomains: domains, 
      DomainListDisabled:false,
      DomainsAddedLimit: this.state.ParentDomainsAddedLimit- domains.length
     });
    if(this.state.ParentDomainsAddedLimit !==-1 && domains.length >= this.state.ParentDomainsAddedLimit){
      this.setState({
        DomainListDisabled: true
      })
    }

  }

  selectAllDisabled(){
    //Unlimited domains can be added
    if(this.state.ParentDomainsAddedLimit === -1){
      return false;
    }else if ( this.props.SuggestedDomains.length > this.state.ParentDomainsAddedLimit){
      return true
    }else{
      return false;
    }
  }

  
  componentWillUpdate(nextProps){
    if(nextProps.domainsAddedLimit !== this.state.ParentDomainsAddedLimit){
      this.setState({
        ParentDomainsAddedLimit: nextProps.domainsAddedLimit
      })
    }
  }

  render() {
    return (
      <Modal show={this.props.showSuggestedDomainsModal} animation={false} className="distkey-modal gc-form">
        <Modal.Header>
          <Modal.Title>Add Previously Registered Domains</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          
          <p>Below are previously registered domains for your account.  You may add these to the current distribution license by selecting them and clicking "Add Hostnames".</p>
          {
            this.state.ParentDomainsAddedLimit !==-1 && 
            <p>You may select up to <b>{this.state.DomainsAddedLimit} more hostname(s).</b></p>

          }
         <div class="distkey-modal-prd-list">
          <DomainList
            domains={this.props.SuggestedDomains}
            onSelectedDomainsChanged={this.selectedDomainsUpdated}
            disabled={this.state.DomainListDisabled}
            selectAllDisabled= { this.selectAllDisabled()}
          />
          </div>
          {this.props.alert && 
            <Alert variant={this.props.alert.Status}>{this.props.alert.Message}</Alert>}   
        </Modal.Body>

        <Modal.Footer>
          {this.props.loading &&
              <i className="fa-spinner fa fa-spin"></i>
          }
          <Button className="gc-btn primary-action" onClick={this.submitAddDomain}>Add Hostnames</Button>
          <Button className="gc-btn" onClick={this.handleModalClose}>Close</Button> 
        </Modal.Footer>
      </Modal>
    )
  }
}

export default SuggestedDomainModal;